import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda10 = () => {

  return (<>
    <PageHeader
    title="Scheda 10"
    description="CRITERI VALUTAZIONE RILEVANZA RISCHI DI IMPATTO E FINANZIARI"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>Sempre con riferimento ai principi ESRS per la identificazione IRO (IMPATTI, RISCHI, OPPORTUNITA’) le valutazioni sono state articolate secondo i seguenti CRITERI:</p>
            <ul>
              <li>Valutazione della <strong>RILEVANZA DEL GRADO DI RISCHIO</strong> distintamente tra IMPATTO per gli STAKEHOLDER COMUNI e FINANZIARI per gli stakeholder FRUITORI e l’AZIENDA, secondo l’analisi di materialità e la Mappa delle opportunità e rischi sociali della creazione di valore di ALLEGATO 3</li><br/>
              <li>VALUTAZIONE per ciascun ambito, associato sempre alle tipologie A,B,C, degli indicatori relativi a:</li>
              <ul>
                <li>
                  <strong>Ricaduta “INSIDE-OUT”</strong> (“IMPATTO DA INTERNO AD ESTERNO”) DA AZIENDA verso uno STAKEHOLDER della Categoria-Esrs COMUNI.
                </li>
                <li>
                  <strong>Ricaduta “OUTSIDE-IN”</strong> (“FINANZIARIO DA ESTERNO A INTERNO”) DA CONTESTO verso STAKEHOLDER della Categoria-Esrs FRUITORI e quindi verso AZIENDA.    
                </li>
              </ul>
            </ul><br/>
            <p>Per ciascuna di queste ricadute verrà <strong>identificata la rilevanza del RISCHIO</strong> basata sulla valutazione aziendale della situazione di partenza, che tiene conto dei valori iniziali assoluti del periodo precedente a quello della elaborazione, i quali possono costituire anche la base di partenza per la mitigazione dei rischi, sempre riprendendo le esemplificazioni proposte o sostituendole con altre ritenute più significative con maggiore possibilità di misurazione della creazione di valore.</p>
            <p>Disponibilità esemplificazioni di supporto per valutazioni rilevanza rischi pari a n. 66 = 33 ambiti per 2 ricadute di impatto o finanziarie.</p>
            <p>Per entrambe le ricadute di questi rischi verrà data una valutazione su scala pentametrica composta dai seguenti valori: MOLTO-ALTO / ALTO / MEDIO / MODERATO / BASSO</p>
            <p>Utilizzato ancora lo SCHEMA UNIFICATO di rilevazione INPUT per la parte VALUTAZIONI RILEVANZA RISCHI - evidenziata in rosso (V. allegato 12)</p>
            <p>Queste valutazioni saranno rappresentate graficamente sulla “Doppia matrice di materialità” (V. ALLEGATI 13 e 15)</p>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-c">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase C EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda10;
